// extracted by mini-css-extract-plugin
export default {"filterIcon":"LeadsComponent_filterIcon__xZSo4","add-icon":"LeadsComponent_add-icon__SVWCc","icon-24":"LeadsComponent_icon-24__FSlQ1"};